module.exports = __webpack_public_path__ + "static/media/Chewy.ee2a56a3.png";